module.exports = __webpack_public_path__ + "img/win.2d151f1c.png";